import {SelectedTab} from "../components/CompanyNews/NewContent/types"

export type State = {
  isNotificationChecked: boolean
  isPreview: boolean
  currentTab: SelectedTab
  acceptedFile: File | undefined
  acceptedFileVisual: File | undefined
  uploadStatus: string
  uploadName?: string
  modalState?: "PickFromLibrary" | "AcceptTerms" | "ConfirmationScreen"
  isPDFValid: boolean
  uploadErrorMsg: string
  isPooling: boolean
  prevFileId: string
}

export const initialState: State = {
  isNotificationChecked: false,
  isPreview: false,
  currentTab: SelectedTab.IMAGE,
  acceptedFile: undefined,
  acceptedFileVisual: undefined,
  uploadStatus: "",
  uploadName: "",
  modalState: undefined,
  isPDFValid: false,
  uploadErrorMsg: "",
  isPooling: false,
  prevFileId: ""
}

export type Action =
  | {
      type: "SET_NOTIFICATION"
      payload: {isNotificationChecked: boolean}
    }
  | {type: "SET_PREVIEW"}
  | {
      type: "SET_CURRENT_TAB"
      payload: {currentTab: SelectedTab}
    }
  | {
      type: "ACCEPTED_FILE"
      payload: {acceptedFile: File | undefined}
    }
  | {
      type: "ACCEPTED_FILE_VISUAL"
      payload: {acceptedFileVisual: File | undefined}
    }
  | {
      type: "UPLOAD_STATUS"
      payload: {uploadStatus: string; uploadName?: string}
    }
  | {
      type: "SET_MODAL_STATE"
      payload: {modalState?: "PickFromLibrary" | "AcceptTerms" | "ConfirmationScreen"}
    }
  | {
      type: "SET_PDF_ERROR"
      payload: {isPDFValid: boolean}
    }
  | {
      type: "SET_IS_POOLING"
      payload: {isPooling: boolean}
    }
  | {
      type: "SET_UPLOAD_ERROR_MSG"
      payload: {uploadErrorMsg: string}
    }
  | {
      type: "SET_PREV_FILE_ID"
      payload: {prevFileId: string}
    }
  | {
      type: "RESET"
    }

const CultureHubReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_NOTIFICATION": {
      return {
        ...state,
        isNotificationChecked: action.payload.isNotificationChecked
      }
    }
    case "SET_PREVIEW": {
      return {
        ...state,
        isPreview: !state.isPreview
      }
    }
    case "SET_CURRENT_TAB": {
      return {
        ...state,
        currentTab: action.payload.currentTab
      }
    }
    case "ACCEPTED_FILE": {
      return {
        ...state,
        acceptedFile: action.payload.acceptedFile
      }
    }
    case "ACCEPTED_FILE_VISUAL": {
      return {
        ...state,
        acceptedFileVisual: action.payload.acceptedFileVisual
      }
    }
    case "UPLOAD_STATUS": {
      return {
        ...state,
        uploadStatus: action.payload.uploadStatus,
        uploadName: action.payload.uploadName
      }
    }
    case "SET_MODAL_STATE": {
      return {
        ...state,
        modalState: action.payload.modalState
      }
    }
    case "SET_PDF_ERROR": {
      return {
        ...state,
        isPDFValid: action.payload.isPDFValid
      }
    }
    case "SET_IS_POOLING": {
      return {
        ...state,
        isPooling: action.payload.isPooling
      }
    }
    case "SET_UPLOAD_ERROR_MSG": {
      return {
        ...state,
        uploadErrorMsg: action.payload.uploadErrorMsg
      }
    }
    case "SET_PREV_FILE_ID": {
      return {
        ...state,
        prevFileId: action.payload.prevFileId
      }
    }
    case "RESET": {
      return initialState
    }
    default:
      return state
  }
}

export default CultureHubReducer
